/*
 * TODO make sure to define VUE_SENTRY_DSN= in your .env files
 * */
import Vue from "vue";
import * as Sentry from "@sentry/vue";
import * as CONFIG from "@/config.js";

if (CONFIG.SentryURL) {
    Sentry.init({
        Vue,
        dsn: CONFIG.SentryURL,
        attachProps: true,
    });
    console.log("Sentry installed!");
}
